import { reportTrackerFailure } from '../rollbar'
import emitEventResetPassword from './emitEventResetPassword'
import { handleInvalidEventProps as handleInvalidEventProperties } from './validateEventProps'

export default ({ getCalltimePayload, name, version }) =>
  (payload) => {
    const { stage } = payload
    if (!(Number.isInteger(version) && name && stage)) {
      handleInvalidEventProperties(payload)
    }
    return emitEventResetPassword({
      error: (error) => reportTrackerFailure(error, name, payload),
      name,
      payload: {
        ...getCalltimePayload(payload),
      },
      version,
    })
  }
